import { PortalUserRegistration } from './PortalUserRegistration'

/** Manager-initiated onboarding: manager lookup hidden; request auto-approved on submit. */
export function PortalUserRegistrationByManager() {
  return <PortalUserRegistration requestedByManager />
}
